var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#A7AFAF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13 5C8.03 5 4 9.03 4 14H1L4.89 17.89L4.96 18.03L9 14H6C6 10.13 9.13 7 13 7C16.87 7 20 10.13 20 14C20 17.87 16.87 21 13 21C11.07 21 9.32 20.21 8.06 18.94L6.64 20.36C8.27 21.99 10.51 23 13 23C17.97 23 22 18.97 22 14C22 9.03 17.97 5 13 5ZM12 10V15L16.28 17.54L17 16.33L13.5 14.25V10H12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.5e6a1cf0dd533c1e0219158f482c680f.svg";
export { ForwardRef as ReactComponent };